// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__48ZhI","tyre":"style_tyre__7vG80"};